.root {
  padding-bottom: 1.5rem;
  border-bottom: 1px solid var(--gray-400);
}
